import {
  MessageRole,
  type OpenXAgentMessage,
  type RichContent,
  type RichContentAction,
} from '@openx/components-core/lib/AiChat/types.ts';

export type RichContentActionEvent = {
  actionKey: string;
  action: RichContentAction;
  content: RichContent;
  contentKey: string;
};

export type RichContentConfig = {
  /** Keys of rich content that stays interactive. When omitted, all rich content is interactive. */
  activeKeys?: ReadonlySet<string>;
  confirmedActionKeys?: ReadonlySet<string>;
  onAction?: (event: RichContentActionEvent) => void;
};

export const getRichContentKey = (messageTimestamp: string, contentId: string) => `${messageTimestamp}:${contentId}`;

export const getRichContentActionKey = (contentKey: string, actionId: string) => `${contentKey}:${actionId}`;

export const getActiveRichContentKeys = (messages: OpenXAgentMessage[]): Set<string> => {
  const latestKeyByType = new Map<RichContent['type'], string>();

  messages.forEach(message => {
    if (message.role !== MessageRole.AGENT) return;

    message.richContent?.forEach(content => {
      latestKeyByType.set(content.type, getRichContentKey(message.timestamp, content.id));
    });
  });

  return new Set(latestKeyByType.values());
};
